import { render } from "./FenceConfig.vue?vue&type=template&id=c0febc7e&scoped=true"
import script from "./FenceConfig.vue?vue&type=script&lang=js"
export * from "./FenceConfig.vue?vue&type=script&lang=js"

import "./FenceConfig.vue?vue&type=style&index=0&id=c0febc7e&scoped=true&lang=css"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0febc7e"]])

export default __exports__